import React, { createContext, useContext, useState } from 'react';

const ShowTaskEditBoxContext = createContext();

export const ShowTaskEditBoxProvider = ({ children }) => {
  const [showTaskEditBox, setShowTaskEditBox] = useState(false);
  const [targetEditTask, setTargetEditTask] = useState();

  return (
    <ShowTaskEditBoxContext.Provider
      value={{
        showTaskEditBox,
        setShowTaskEditBox,
        targetEditTask,
        setTargetEditTask,
      }}
    >
      {children}
    </ShowTaskEditBoxContext.Provider>
  );
};

export const useShowTaskEditBoxContext = () =>
  useContext(ShowTaskEditBoxContext);
